import { mutations } from "@/constants/state";

export default {
  [mutations.HORECA_LOCATIONS_FETCH_MUTATION]: (state, payload) => {
    state.horecaLocations = payload;
  },
};
